import styles from "./bannerImage.module.css";
import banner from "../../../assets/images/vfbanner.png";
import { SubmitButton } from "../../../components/button/buttons";
import { Banner } from "../../../components/banner/Banners";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import SelectService from "../../demand/template/selectServiceTemplate/selectService";
import { AMEND_SERVICE } from "../../../utils/constants/serviceConstants";
import { Action, Resource } from "../../../casl/constants";
import CAN from '../../../casl/can';
import SectionGuard from "../../../hoc/guards/SectionGuard";


function BannerImage(props) {
   const navigate = useNavigate();
   const [isOpen, setIsOpen] = useState(false)
   const openPopup = () => setIsOpen(true);
   const closePopup = () => setIsOpen(false);

 
const handleServiceClick = (mode) => {
 navigate(`/connectivity/demand/${mode}`)
  closePopup(); 
};

  return (
    <Banner
          image={banner}
          text={props?.bannerTitle}
        >
        <div style={{display:"flex", gap:"10px"}}>
          {props?.canCreateNewService && (
            // <SubmitButton
            //   type="button"
            //   style={styles.submitButton}
            //   onClick={props?.openForm}
            // >
            //   Raise New Demand
            // </SubmitButton>
            <SubmitButton  style={styles.submitButton} onClick={openPopup}> Raise New Demand</SubmitButton>
          )}
          {isOpen && (
            <SelectService isOpen={isOpen} onClose={closePopup} onSelect={handleServiceClick} isInternalUser={props.isInternalUser}/>
            )}
          <SectionGuard canAccess={CAN(Action.LIST,Resource.LIVE_SERVICES) && CAN(Action.CREATE,Resource.DEMANDS) && !props.isInternalUser}>
           <SubmitButton
              type="button"
              style={styles.submitButton}
              onClick={()=>handleServiceClick(AMEND_SERVICE)}
            >
              Amend Service
            </SubmitButton>
          </SectionGuard>
        </div>
        </Banner>
  );
}
export default BannerImage;
